module.exports = __webpack_public_path__ + "static/media/tt-icon.efd366b0.svg";